export const menuActions = {
    DOWNLOAD_ORDER_OVERVIEW: 'DOWNLOAD_ORDER_OVERVIEW',
    DOWNLOAD_PRODUCT_DATA: 'DOWNLOAD_PRODUCT_DATA'
};

export const orderTypes = {
    REORDER: 'b2b-order',
    PREORDER: 'preorder'
};

export const orderClientTypes = {
    REORDER: 'fc-platform'
};
